import React from "react"
import { css } from "@emotion/core"
import { Link } from "gatsby"
import t, { mixin } from "theme"

const Footer = ({ ...props }) => {
    return (
        <div
            css={css`
                display: flex;
                justify-content: space-between;
                width: 100%;
                margin: ${t.space[6]} auto;
                max-width: ${t.sitewide.containerWidth};
                ${mixin.defaultSidePadding};

                ${mixin.tabletandphonestyle} {
                    flex-direction: column;
                }
            `}
            {...props}>
            <div>&#169; {new Date().getFullYear()} Disruption Research</div>

            <div
                css={css`
                    display: flex;
                    ${mixin.tabletandphonestyle} {
                        flex-direction: column;
                    }
                `}>
                <Link
                    to="/about"
                    css={css`
                        margin-right: ${t.space[6]};
                    `}>
                    ABOUT
                </Link>

                <Link
                    to="/legal/terms-service"
                    css={css`
                        margin-right: ${t.space[6]};
                    `}>
                    TERMS OF SERVICE
                </Link>

                <Link to="/legal/privacy-policy">PRIVACY POLICY</Link>
            </div>
        </div>
    )
}

export default Footer
